import { filterNullishCriteria } from './utils';

export const createSearchParams = (request: Request) => {
  return new URLSearchParams(request.url.split('?')?.[1]);
};

export const replaceUrlWithParams = (
  url: string,
  criteria: Record<string, string>
): void => {
  const params = new URLSearchParams(filterNullishCriteria(criteria));
  window.history.replaceState(null, '', `${url}?${params}`);
};

export const getSearchParamValue = <T = string>(
  params: URLSearchParams | undefined,
  key: string
): T | undefined => {
  if (!params) return undefined;

  const value = params.get(key);
  return (value as T) ?? undefined;
};

export const getSearchParamValues = <T = string>(
  params: URLSearchParams | undefined,
  key: string
): T[] | undefined => {
  if (!params) return undefined;

  const values = params.getAll(key);
  return values.length > 0 ? (values as T[]) : undefined;
};
